<template>
  <div class="periodo-mensuracao" :class="{ 'error-scroller': initialDateError || finalDateError, 'pb-0': true }">
    <v-container class="pa-0" fluid>
      <v-row>
        <v-col :cols="cols * 2" class="py-0">
          <h3 class="periodo-card-title">
            <slot name="titulo">Período de mensuração</slot>
          </h3>
          <p class="periodo-card-text mb-2">
            <slot>Por quanto tempo você quer mensurar os resultados dessa campanha?</slot>
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <tooltip fit-content align="right" :disabled="!isIndustryCampaign" :message="tooltipMessage">
            <mf-date-range-picker
              class="date-range-picker"
              :label="label"
              :min="minInitialDate"
              :initial-date.sync="computedInitialDate"
              :final-date.sync="computedFinalDate"
              :disabled="disabled"
              :error-messages="errorDates"
              :edit-only-end-date="editOnlyEndDate"
              outlined
              icon
            />
          </tooltip>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  components: {
    Tooltip: () => import('@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip.vue'),
  },
  props: {
    initialDate: String,
    finalDate: String,
    sendDate: String,
    initialDateError: Boolean,
    initialDisabled: Boolean,
    disabled: Boolean,
    finalDateError: Boolean,
    labelInicio: String,
    labelFinal: String,
    cols: {
      default: 6,
    },
    label: {
      type: String,
      default: 'Período de mensuração',
    },
    errorMessages: {
      type: [Array, String],
      default: 'Selecione o período de mensuração',
    },
    editOnlyEndDate: {
      type: Boolean,
      default: false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
    isIndustryCampaign: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    minInitialDate() {
      return this.sendDate || DateTime.now().toFormat('yyyy-MM-dd')
    },
    errorDates() {
      return this.initialDateError || this.finalDateError ? this.errorMessages : ''
    },
    computedInitialDate: {
      get() {
        return this.initialDate
      },
      set(value) {
        this.$emit('update:initialDate', value)
      },
    },
    computedFinalDate: {
      get() {
        return this.finalDate
      },
      set(value) {
        this.$emit('update:finalDate', value)
      },
    },
  },
  methods: {
    inputInitialDate(value) {
      this.$emit('update:initialDate', value)
      this.$emit('update:finalDate', '')
    },
  },
}
</script>
<style lang="scss" scoped>
.periodo-mensuracao {
  .periodo-card-title {
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 400;
    color: $cinza-d10;
  }
  .periodo-card-text {
    opacity: 0.8;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.233333px;
  }
  ::v-deep.v-input__slot {
    width: 264px;
    margin-top: 5px;
  }
}
</style>
